module.exports = __webpack_public_path__ + "edc54b09edd4a6c5da7f422076bf3276.pdf";